<small>&copy; {{settings.copyright.year}} - {{ settings.copyright.organization }}</small>
